import { IClauseEntity } from '../../entitites/common/clause.entity';
import { IDocumentCollection } from '../../entitites/common/document-collection.entity';
import { ClauseDto } from './clause.dto';
import { StaticDocumentDto } from './static-document.dto';

export class DocumentCollectionProductDto {
  readonly name: string;
  readonly code: string;
  readonly object: {
    guid: string;
    reference: string;
  };
  readonly composition?: {
    guid: string;
    reference: string;
  };
  readonly documents: Array<StaticDocumentDto>;
  readonly clauses: Array<ClauseDto>;
  readonly options: Array<{
    name: string;
    code: string;
    documents: Array<StaticDocumentDto>;
    clauses: Array<ClauseDto>;
  }>;
  readonly addons: Array<{
    name: string;
    code: string;
    documents: Array<StaticDocumentDto>;
    clauses: Array<ClauseDto>;
  }>;

  constructor(
    entity: IDocumentCollection['products'][number],
    origin?: string,
  ) {
    this.name = entity.name;
    this.code = entity.code;
    this.object = entity.object;
    this.composition = entity.composition;
    this.documents = entity.documents.map(
      (document) => new StaticDocumentDto(document, origin),
    );
    this.clauses = entity.clauses.map((clause) => new ClauseDto(clause));
    this.options = entity.options.map((option) => ({
      ...option,
      documents: option.documents.map(
        (document) => new StaticDocumentDto(document, origin),
      ),
      clauses: option.clauses.map((clause) => new ClauseDto(clause)),
    }));

    this.addons = entity.addons.map((addon) => ({
      ...addon,
      documents: addon.documents.map(
        (document) => new StaticDocumentDto(document, origin),
      ),
      clauses: addon.clauses.map((clause) => new ClauseDto(clause)),
    }));
  }
}

export class DocumentCollectionDto {
  readonly products: Array<{
    name: string;
    code: string;
    object: {
      guid: string;
      reference: string;
    };
    composition?: {
      guid: string;
      reference: string;
    };
    documents: Array<StaticDocumentDto>;
    clauses: Array<IClauseEntity>;
    options: Array<{
      name: string;
      code: string;
      documents: Array<StaticDocumentDto>;
      clauses: Array<IClauseEntity>;
    }>;
    addons: Array<{
      name: string;
      code: string;
      documents: Array<StaticDocumentDto>;
      clauses: Array<IClauseEntity>;
    }>;
  }>;

  readonly documents: Array<StaticDocumentDto>;

  constructor(entity: IDocumentCollection, origin?: string) {
    this.products = entity.products.map(
      (product) => new DocumentCollectionProductDto(product, origin),
    );
    this.documents = entity.documents.map(
      (document) => new StaticDocumentDto(document, origin),
    );
  }
}
